<template>
  <el-row class="home" :gutter="40">
    <el-col class="left-content" :span="8">
      <div class="grid-content">
        <div class="text-center">
          <h3>{{ tenant.tenantName }}</h3>
          <el-button class="btn-state" type="primary" size="small" @click="invokeAuth">{{ checkStatusMsg }}</el-button>
        </div>
        <div class="block">
          <el-row type="flex" justify="space-between">
            <div>
              账户信息
            </div>
            <div class="details">
              {{ tenant.tenantId }}
            </div>
          </el-row>
          <el-row type="flex" justify="space-between">
            <div>
              企业联系人
            </div>
            <div class="details">
              {{ tenant.clientName }}
            </div>
          </el-row>
          <el-row type="flex" justify="space-between">
            <div>
              账户状态
            </div>
            <div class="details">
              <span class="text-danger">{{ expireStatusMsg }}</span>
            </div>
          </el-row>
          <!-- <el-row type="flex" justify="space-between">
            <div>
              登录地址
            </div>
            <div class="details">
              {{ loginAddress }}
            </div>
          </el-row> -->
        </div>
        <div class="block">
          <el-row type="flex" justify="space-between">
            <div>
              订购主套餐
            </div>
            <div class="details">
              <span class="text-bg">{{orderInfo.schemeName}}</span>
            </div>
          </el-row>
          <el-row type="flex" justify="space-between">
            <div>
              包含应用
            </div>
            <div class="details">
              <span>{{extendedApps}}</span>
            </div>
          </el-row>
          <el-row type="flex" justify="space-between">
            <div>
              创建账号上限
            </div>
            <div class="details">
              {{orderInfo.seatLimit}}
            </div>
          </el-row>
          <el-row type="flex" justify="space-between">
            <div>
              技能组创建上限
            </div>
            <div class="details">
              {{orderInfo.skillGroupLimit}}
            </div>
          </el-row>
          <el-row type="flex" justify="space-between">
            <div>
              渠道创建上限
            </div>
            <div class="details">
              {{orderInfo.channelLimit}}
            </div>
          </el-row>
          <el-row type="flex" justify="space-between">
            <div>
              并发登录上限
            </div>
            <div class="details">
              {{orderInfo.accessLimit}}
            </div>
          </el-row>
        </div>
      </div>
    </el-col>
    <el-col :span="16" style="padding-right: 0">
      <div class="grid-content">
        <div class="banner">
          <img src="@/assets/images/home-pic01.png" alt="云客服企业管理台" />
        </div>
        <div class="notice">
          <div class="notice-title">
            <h4>通知公告</h4>
          </div>
          <div class="notice-content">
            <ul>
              <li class="item">
                <a href="">
                  <el-row type="flex" justify="space-between">
                    <div>
                      迎新活动大优惠 | 系统
                    </div>
                    <div class="time">
                      2020-08-16
                    </div>
                  </el-row>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </el-col>
    <el-row>
      <el-dialog title="明细" :visible.sync="dialogVisible">
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </el-row>
  </el-row>
</template>

<script>

import { convertAliasField } from '@/utils/tenant-table-map'

export default {
  name: '',
  data() {
    return {
      tenant: {
        tenantName: '',
        tenantId: '',
        clientName: ''
      },
      checkStatusMsg: '',
      expireStatusMsg: '',
      // loginAddress: 'shabcm01.xiaoicc.com'
      orderInfo: {
        schemeName: '',
        apps: [],
        seatLimit: 0,
        channelLimit: 0,
        skillGroupLimit: 0,
        accessLimit: 0
      },
      dialogVisible: false
    }
  },
  computed: {
    extendedApps: function () {
      if (this.orderInfo) {
        const apps = this.orderInfo.apps
        let result = ''
        for (let i = 0; i < apps.length; i++) {
          if (i > 0) {
            result = result + '/'
          }
          result = result + apps[i].appName
        }

        console.log(result)

        return result
      } else {
        return '-'
      }
    }
  },
  components: {},
  mounted() {
  },
  created() {
    this.basicInfo()
    this.getCurrentOrderInfo()
  },
  methods: {
    basicInfo: function () {
      this.$http.get(window.$envUtils('VUE_APP_BP_SERVICE') + '/data/tenant_info/get?tenantId=' + localStorage.getItem('X-TENANT-ID')).then(res => {
        if (res.data.code === 2000) {
          const data = convertAliasField('EndToFront', res.data.data[0])
          if (data.checkStatus === 1 || data.checkStatus === 4) {
            this.checkStatusMsg = '未认证'
          } else if (data.checkStatus === 2) {
            this.checkStatusMsg = '认证中'
          } else if (data.checkStatus === 3) {
            this.checkStatusMsg = '已认证'
          }

          if (data.currentOrder) {
            const endTime = new Date(data.currentOrder.endTime).getTime()
            const now = new Date().getTime()
            const duration = endTime - now
            // 大于7天,套餐正常
            if (duration >= 604800000) {
              this.expireStatusMsg = '订单正常'
            } else if (duration >= 0) {
              this.expireStatusMsg = '订单即将到期'
            } else {
              this.expireStatusMsg = '订单已过期'
            }
          }
          this.tenant = data
        }
      })
    },
    showOwnedApps: function () {
      this.dialogVisible = true
    },
    getCurrentOrderInfo: function () {
      this.$http.get(window.$envUtils('VUE_APP_BP_SERVICE') + '/data/tenant_info/getCurrentOrderInfo?tenantId=' + localStorage.getItem('X-TENANT-ID')).then(res => {
        const orderInfo = res.data.data
        if (orderInfo) {
          this.orderInfo = orderInfo
          console.log(orderInfo)
        }
      })
    },
    invokeAuth: function () {
      this.$router.push({
        path: '/home/authentication',
        query: {
          checkStatusMsg: this.checkStatusMsg
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.home {
  display: flex;
  align-items: stretch;
  margin-left: 0 !important;
  margin-right: 0 !important;
  font-size: 14px;
  color: #333;
  .left-content {
    padding: 30px 20px 15px !important;
    border: 1px solid #ebebeb;
    h3 {
      color: #000;
      margin-top: 10px;
      margin-bottom: 20px;
    }
    .btn-state {
      border-radius: 20px;
      padding: 5px 11px;
      margin-bottom: 30px;
    }
    .block {
      border-top: 1px solid #ebebeb;
      padding: 30px 0;
      line-height: 2;
      .details {
        color: #666;
        .text-bg {
          background-color: #eeeff2;
          font-size: 12px;
          border-radius: 2px;
          padding: 4px 12px;
        }
        .icon {
          font-size: 16px;
        }
      }
    }
  }
  .banner {
    background-color: #310274;
    img {
      display: block;
    }
  }
  .notice {
    margin-top: 15px;
    border: 1px solid #ebebeb;
    .notice-title {
      height: 45px;
      line-height: 45px;
      padding-left: 40px;
      background-color: #f5f5f5;
      h4 {
        position: relative;
        color: #222;
        font-size: 16px;
        &:before {
          content: "";
          position: absolute;
          left: -20px;
          top: 15px;
          width: 3px;
          height: 14px;
          background-color: #337eff;
          border-radius: 2px;
        }
      }
    }
    .notice-content {
      padding: 0 20px 20px;
      .item {
        position: relative;
        height: 42px;
        line-height: 42px;
        padding-left: 20px;
        overflow: hidden;
        border-bottom: 1px dashed #ebebeb;
        &:before {
          content: "";
          position: absolute;
          left: 0;
          top: 18px;
          width: 6px;
          height: 6px;
          background-color: #e5e5e5;
          border-radius: 50%;
        }
        a {
          &:hover {
            color: #000;
          }
        }
        .time {
          color: #aaa;
        }
      }
    }
  }
}
</style>
